<template>
  <el-container height="100%">
    <el-header>
      <el-container class="nav-header">
        <el-aside class="title" width="230px" v-show="titleShow"
          >网班系统管理员后台</el-aside
        >
        <el-main class="text-right">
          <!-- <span class="org_name">管理员</span>
          <span></span> -->
          <i
            class="el-icon-s-unfold"
            style="font-size:25px;cursor: pointer;"
            @click="openSide"
            v-if="isCollapse == true"
          ></i>
          <i
            class="el-icon-s-fold"
            style="font-size:25px;cursor: pointer;"
            @click="closeSide"
            v-else
          ></i>
          <div class="quit">
            <el-select
              class="org"
              v-model="localOrg"
              @change="handChange"
              placeholder="切换机构"
            >
              <el-option
                v-for="item in orgs"
                :key="item.number"
                :label="item.name + '(' + item.number + ')'"
                :value="item.number"
              >
              </el-option>
            </el-select>
            <span class="logout" @click="logout">退出</span>
          </div>
        </el-main>
      </el-container>
    </el-header>
    <el-container class="cont-body">
      <el-aside class="asideMenu" style="with:230px">
        <el-radio-group v-model="isCollapse" v-show="radioButton">
          <el-radio-button :label="false">展开</el-radio-button>
          <el-radio-button :label="true">收起 </el-radio-button>
        </el-radio-group>
        <el-menu
          router
          default-active="1"
          class="el-menu-vertical-demo"
          :collapse="isCollapse"
        >
          <el-menu-item
            v-if="item.hidden == false"
            @select="link"
            v-for="(item, index) in routerList"
            :key="index"
            :index="item.path"
          >
            <i class="el-icon-menu"></i>
            <span slot="title">{{ item.meta.title }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main height="100%" class="main" :class="margin_l">
        <transition name="slide-fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  name: 'Layouts',
  data() {
    return {
      routerList: [],
      loginCustomer: '',
      orgs: [],
      localOrg: {},
      isCollapse: false,
      margin_l: 'marginLeft_show',
      radioButton: false,
      titleShow: true,
    }
  },
  watch: {
    isCollapse: {
      handler: function(newValue) {
        if (this.isCollapse == true) {
          this.margin_l = 'marginLeft_hidden'
        } else {
          this.margin_l = 'marginLeft_show'
        }
      },
      deep: true,
    },
  },
  created() {
    let _this = this
    let list = this.$router.options.routes
    //_this.loginCustomer = _this.Storage.getStorage("userinfo").name;
    list.forEach(element => {
      if (element.children) {
        element.children.forEach(e => {
          _this.routerList.push(e)
        })
      }
    })

    if (this.Storage.getStorage('orgs') == null) {
      this.getOrg()
    } else {
      this.orgs = this.Storage.getStorage('orgs')
      this.localOrg = this.Storage.getStorage('orgNumber')
      this.sort()
    }
  },
  methods: {
    getOrg() {
      let _this = this
      this.$http
        .post(process.env.VUE_APP_URL + 'getOrg')
        .then(function(data) {
          if (data.data.code == 200) {
            let org = data.data.org
            if (org.length > 0) {
              _this.Storage.setStorage('orgNumber', data.data.data) //存储所选机构的number
              _this.setCookie('jid', data.data.data)
              _this.Storage.setStorage('orgs', org) //存储所有机构
              _this.orgs = org
              _this.localOrg = data.data.data
            }
            _this.sort()
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          _this.$message.error('网络错误,请刷新界面重试')
          return
        })
    },
    sort() {
      this.orgs.sort(function(a, b) {
        return a.name.localeCompare(b.name)
      })
    },
    openSide() {
      this.isCollapse = false
      this.titleShow = true
    },
    closeSide() {
      this.isCollapse = true
      this.titleShow = false
    },
    link(name) {
      let _this = this
      this.$router.push({ name: name })
    },
    logout() {
      let _this = this
      this.setCookie('loginid', '')
      localStorage.clear('orgNumber')
      _this.$router.push({ path: '/login/' })
      localStorage.clear()
      sessionStorage.clear()
    },
    handChange(val) {
      this.Storage.setStorage('orgNumber', val)
      this.setCookie('jid', val)
      this.localOrg = val
      window.location.href = ''
    },
  },
}
</script>
<style scoped>
.el-header {
  background-color: #29b084;
  color: #333;
  height: 60px;
  padding: 0px;
  position: fixed;
  width: 100%;
  z-index: 999;
}
.main {
  height: 100%;
  /* margin-left: 230px; */
  background-color: #f0f3f4;
}
.marginLeft_show {
  margin-left: 230px;
}
.marginLeft_hidden {
  margin-left: 50px;
}
.nav-header {
  color: #fff;
}
.nav-header .el-aside {
  background-color: #1f8463;
}
.nav-header .el-main {
  padding: 19px;
}
.nav-header .el-main span {
  font-size: 16px;
  margin-right: 15px;
}
.nav-header .el-main .el-icon-setting {
  font-size: 16px;
  margin-right: 15px;
}

.el-menu {
  height: 100%;
}
.org_name {
  float: left;
  margin-left: 10px;
}
.cont-body {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
}
.slide-fade-enter-active {
  transition: all 0.5s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.asideMenu {
  width: 230px !important;
  height: 100%;
  position: fixed;
}
.title {
  line-height: 60px;
  height: 60px;
  padding-left: 40px;
}
.quit {
  float: right;
}
.org {
  margin-right: 20px;
}
.logout {
  cursor: pointer;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
/deep/.el-radio-button__inner {
  padding: 10px 17px;
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #29b084;
  border: #29b084;
}
</style>
